import { render, staticRenderFns } from "./ModalEdicaoRestricoes.vue?vue&type=template&id=6880ea68&lang=pug"
import script from "./ModalEdicaoRestricoes.vue?vue&type=script&lang=js"
export * from "./ModalEdicaoRestricoes.vue?vue&type=script&lang=js"
import style0 from "./ModalEdicaoRestricoes.vue?vue&type=style&index=0&id=6880ea68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports